import { useState } from 'react';
import { useMutation } from 'react-query';
import { useNavigate } from 'react-router-dom';
import { backend } from '../axios/backend';
import AddPersonModal from '../components/AddPersonModal';
import PrettyLoader from '../components/PrettyLoader';
import Plus from '../components/icons/Plus';
import StarOutline from '../components/icons/StarOutline';
import StarSolid from '../components/icons/StarSolid';
import Button from '../components/ui/Button';
import IconButton from '../components/ui/IconButton';
import Input from '../components/ui/Input';
import { usePersons } from '../hooks/usePersons';

export type PersonResponse = {
  id: string;
  name: string;
  isFavorite: boolean;
  dateOfBirth?: Date;
  addedBy: string;
};

const MyIdeasPage = () => {
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const query = usePersons();

  const updatePersonMutation = useMutation(
    (options: { personId: string; name?: string; isFavorite?: boolean }) =>
      backend.patch(`person/${options.personId}`, { name: options.name, isFavorite: options.isFavorite }),
    { onError: () => { }, onSuccess: () => query.refetch() },
  );

  return (
    <div style={{ margin: '2rem' }} className="space-y-2">
      <div className="flex flex-row justify-between items-center">
        <h1 className="text-white text-xl">
          <b>Ideen</b>
        </h1>

        <IconButton onClick={() => setIsModalOpen(true)} Icon={Plus} />
      </div>
      <p className="text-white">Hier kannst deine Geschenkideen für verschiedene Personen sammeln und verwalten.</p>

      <PrettyLoader useQueryResult={query}>
        <ul className="divide-y divide-gray-400 mb-4">
          {query.data?.map((person) => (
            <li
              key={person.id}
              onClick={() => navigate(`/ideas/${person.id}`)}
              className="py-4 flex justify-between items-center text-white cursor-pointer"
            >
              <span>{person.name}</span>
              <span className="items-center">
                <IconButton
                  id={`fav-button-${person.id}`}
                  onClick={(e) => {
                    e.stopPropagation();
                    updatePersonMutation.mutate({ personId: person.id, isFavorite: person.isFavorite ? false : true });
                  }}
                  Icon={person.isFavorite ? StarSolid : StarOutline}
                  variant="primary-muted"
                />
              </span>
            </li>
          ))}
        </ul>
        <div className="flex flex-row space-x-4">
          <Input name='add-person' value='' onChange={() => { }} placeholder='Name der Person' onClick={() => setIsModalOpen(true)} />
          <Button onClick={() => setIsModalOpen(true)} Icon={Plus}>
            Person
          </Button>
        </div>
      </PrettyLoader>
      <AddPersonModal isOpen={isModalOpen} setIsOpen={setIsModalOpen} />
    </div>
  );
};

export default MyIdeasPage;
